"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackOrderPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var main_1 = require("../../../reducers/slices/main");
var why_shop_with_us_1 = require("./components/why_shop_with_us");
var parcel_tracking_1 = require("../../../api/calls/order/parcel_tracking");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var search_order_1 = require("../../../api/calls/order/search_order");
var TrackOrderPage = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _a = (0, react_1.useState)(""), orderNumber = _a[0], setOrderNumber = _a[1];
    var _b = (0, react_1.useState)(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = (0, react_1.useState)(""), orderNumberErrorText = _c[0], setOrderNumberErrorText = _c[1];
    var _d = (0, react_1.useState)(), orderDetails = _d[0], setOrderDetails = _d[1];
    var _e = (0, react_1.useState)(0), currentStep = _e[0], setCurrentStep = _e[1];
    var _f = (0, react_1.useState)([]), customSteps = _f[0], setCustomSteps = _f[1];
    var _g = (0, react_1.useState)([
        {
            label: "Checked Out",
            hidden: true,
            component: (react_1.default.createElement("div", { className: "flex flex-row gap-4 w-full justify-center items-center" },
                react_1.default.createElement("div", { className: "text-primary" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faMoneyBill, size: "xl" })),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { bold: true, center: true, size: "medium", uppercase: true, label: "Checked Out" }))),
        },
        {
            label: "Received",
            component: (react_1.default.createElement("div", { className: "flex flex-row gap-4 w-full justify-center items-center" },
                react_1.default.createElement("div", { className: "text-primary" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faListCheck, size: "xl" })),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { bold: true, center: true, size: "medium", uppercase: true, label: "Received" }))),
        },
        {
            label: "Processed",
            component: (react_1.default.createElement("div", { className: "flex flex-row gap-4 w-full justify-center items-center" },
                react_1.default.createElement("div", { className: "text-primary" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faRotate, size: "xl" })),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { bold: true, center: true, size: "medium", uppercase: true, label: "Processed" }))),
        },
    ]), initialSteps = _g[0], setInitialSteps = _g[1];
    // useEffect(() => {
    //   getOrderData();
    //   //
    // }, [orderNumber]);
    (0, react_1.useEffect)(function () {
        var _a;
        if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.type) == "COLLECTION") {
            setCustomSteps(__spreadArray(__spreadArray([], initialSteps, true), [
                {
                    label: "Ready for collection",
                    component: (react_1.default.createElement("div", { className: "flex flex-row gap-4 w-full justify-center items-center" },
                        react_1.default.createElement("div", { className: "text-primary" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPersonCarryBox, size: "xl" })),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { bold: true, center: true, size: "medium", uppercase: true, label: "Ready for collection" }))),
                },
                {
                    label: "Collected",
                    component: (react_1.default.createElement("div", { className: "flex flex-row gap-4 w-full justify-center items-center" },
                        react_1.default.createElement("div", { className: "text-primary" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCheck, size: "xl" })),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { bold: true, center: true, size: "medium", uppercase: true, label: "Collected" }))),
                },
            ], false));
        }
        else if ((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.type) == "DELIVERY") {
            setCustomSteps(__spreadArray(__spreadArray([], initialSteps, true), [
                {
                    label: "Ready for delivery",
                    component: (react_1.default.createElement("div", { className: "flex flex-row gap-4 w-full justify-center items-center" },
                        react_1.default.createElement("div", { className: "text-primary" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTruckRampBox, size: "xl" })),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { bold: true, center: true, size: "medium", uppercase: true, label: "Ready for delivery" }))),
                },
                {
                    label: "In Transit",
                    component: (react_1.default.createElement("div", { className: "flex flex-row gap-4 w-full justify-center items-center" },
                        react_1.default.createElement("div", { className: "text-primary" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTruckFast, size: "xl" })),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { bold: true, center: true, size: "medium", uppercase: true, label: "In Transit" }))),
                },
                {
                    label: "Delivered",
                    component: (react_1.default.createElement("div", { className: "flex flex-row gap-4 w-full justify-center items-center" },
                        react_1.default.createElement("div", { className: "text-primary" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCheck, size: "xl" })),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { bold: true, center: true, size: "medium", uppercase: true, label: "Delivered" }))),
                },
            ], false));
        }
        switch ((_a = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) === null || _a === void 0 ? void 0 : _a.toUpperCase()) {
            case "ORDERED":
            case "OPEN":
                setCurrentStep(1);
                break;
            case "PACKED":
                setCurrentStep(2);
                break;
            case "COLLECTION-READY":
            case "DELIVERY-READY":
                setCurrentStep(3);
                break;
            case "COLLECTED":
            case "IN-TRANSIT":
                setCurrentStep(4);
                break;
            case "DELIVERED":
                setCurrentStep(5);
                break;
            default:
                setCurrentStep(1);
        }
    }, [orderDetails]);
    var getOrderData = function () {
        if (orderNumber) {
            setIsLoading(true);
            setOrderNumberErrorText("");
            (0, parcel_tracking_1.parcel_tracking)({
                code: orderNumber,
            }).then(function (response) {
                setIsLoading(false);
                if (response.success) {
                    if (response.content == null) {
                        (0, search_order_1.search_order)({
                            search_string: orderNumber !== null && orderNumber !== void 0 ? orderNumber : "",
                        }).then(function (response) {
                            setIsLoading(false);
                            if (response.success) {
                                setOrderDetails(response.content);
                            }
                            else {
                                dispatch((0, main_1.setMessageModal)({
                                    title: "Could not get order details!",
                                    messages: [response.message],
                                }));
                            }
                        });
                    }
                    else {
                        setOrderDetails(response.content);
                    }
                }
                else {
                    dispatch((0, main_1.setMessageModal)({
                        title: "Could not get order!",
                        messages: [response.message],
                    }));
                }
            });
        }
        else {
            setOrderNumberErrorText("Invalid Order Number entered");
        }
    };
    // O-U5YTRE
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-8" },
            isLoading ? (react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "large", progressColor: "text-primary" })) : (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Track Your Order", textColor: "text-black", size: "3xlarge", bold: true }),
                    user._id ? (react_1.default.createElement("div", { className: "" },
                        react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "View my orders", textColor: "text-link", onClick: function () {
                                navigate("/orders");
                            } }))) : (react_1.default.createElement("div", { className: "flex flex-wrap" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "If you have an existing online profile, ", textColor: "text-black", size: "small" }),
                        react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "log in to view your full order history", textColor: "text-link", onClick: function () {
                                dispatch((0, main_1.setDrawerPage)("login"));
                                dispatch((0, main_1.setDrawerOpen)(true));
                            }, size: "small" }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: ", or use the form below to track a single order.", textColor: "text-black", size: "small" })))),
                orderDetails && customSteps.length > 0 ? (react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "flex  flex-col gap-4" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Order Number: ".concat(orderNumber), textColor: "text-black", size: "small" }),
                        react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Track another order", textColor: "text-primary", size: "small", onClick: function () {
                                setOrderDetails(null);
                                setOrderNumber("");
                            } }),
                        react_1.default.createElement(doshx_controls_web_1.StepperControl, { currentStep: currentStep, steps: customSteps, orientation: "horizontal", stepsPadding: true, stepPillCompletedBackgroundColor: "bg-primary", stepPillBackgroundColor: "bg-secondary", stepTitleColor: "text-black", stepPillTextColor: "text-primary", lineColor: "border-primary" })))) : (react_1.default.createElement("div", { className: "flex flex-col gap-4 w-full md:w-2/5" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Example: O-ABC123", size: "small" }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Order Number", borderColor: "border-[#EEEEEE]", value: orderNumber, errorText: orderNumberErrorText, onChange: function (v) {
                            setOrderNumber(v);
                        } }),
                    react_1.default.createElement("div", { className: "pt-4 flex flex-row self-stretch" },
                        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "SUBMIT", backgroundColor: "bg-primary", size: "medium", onClick: function () {
                                getOrderData();
                            } })))))),
            react_1.default.createElement(why_shop_with_us_1.WhyShopWithUsComponent, null))));
};
exports.TrackOrderPage = TrackOrderPage;
